import axios from "axios";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

/* ======================
   BASE URL
====================== */
 // const baseUrl = "http://localhost:2000/api";
const baseUrl = "https://mctp2muat.mindscraft.pk/api"
//const baseUrl = "http://203.175.74.144:12000/api"
const api = axios.create({
  baseURL: baseUrl,
  headers: { "Content-Type": "application/json" },
});

/* ======================
   INTERCEPTORS
====================== */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && [401, 403].includes(error.response.status)) {
      localStorage.removeItem("token");
      history.push("/");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

/* ======================
   AUTH
====================== */
export const requestOtpApi = async (email) => {
  const res = await api.post("/auth/request-otp", { email });
  return res.data;
};

export const verifyOtpApi = async (email, otp) => {
  const res = await api.post("/auth/verify-otp", { email, otp });
  return res.data;
};

export const resendOtpApi = async (email) => {
  const res = await api.post("/auth/resend-otp", { email });
  return res.data;
};

/* ======================
   SYSTEM / DASHBOARD
====================== */
export const getSystemDashboardStats = async () => {
  const res = await api.get("/system/dashboard-stats");
  return res.data;
};
export const getSystemDashboardChartsStats = async (range) => {
  const res = await api.get(`/system/transactions?range=${range}`);
  return res.data;
};

/* ---- Admin Dashboard (new endpoints) ---- */
export const getDashboardSummary = async () => {
  const res = await api.get("/system/dashboard/summary");
  return res.data;
};
export const getDashboardTrends = async (range = "week") => {
  const res = await api.get(`/system/dashboard/transaction-trends?range=${range}`);
  return res.data;
};
export const getDashboardQrAdoption = async () => {
  const res = await api.get("/system/dashboard/qr-adoption");
  return res.data;
};
export const getDashboardRecentActivities = async (limit = 10) => {
  const res = await api.get(`/system/dashboard/recent-activities?limit=${limit}`);
  return res.data;
};
export const getDashboardTopOrganizations = async (limit = 5) => {
  const res = await api.get(`/system/dashboard/top-organizations?limit=${limit}`);
  return res.data;
};
/* ======================
   ORGANIZATION
====================== */
export const onboardOrganization = async (payload) => {
  const res = await api.post("/org/onboard", payload);
  return res.data;
};

export const getOrgDashboardStats = async (orgId) => {
  const res = await api.get(`/org/org-dashboard?orgId=${orgId}`);
  return res.data;
};
export const getAllOrganizations = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    search = "",
    industrySector = "all",
    status = "all",
    registrationDate = "all",
  } = params;

  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    industrySector,
    status,
    registrationDate,
  });
  if (search) query.set("search", search);

  const res = await api.get(`/org/allorganizations?${query.toString()}`);
  return res.data;
};
export const getOrgDetailDashboard = async (orgId) => {
  const res = await api.get(`/org/detail-dashboard/${orgId}`);
  return res.data;
};
export const getOrgAuditTimeline = async (orgId, limit = 20) => {
  const res = await api.get(`/org/audit-timeline/${orgId}?limit=${limit}`);
  return res.data;
};
export const getOrganizationStats = async (orgId) => {
  const res = await api.get(`/org/${orgId}`);
  return res.data;
};
export const updateOrganization = async (orgId, data) => {
  const response = await api.put(`/org/update/${orgId}`, data);
  return response.data;
};
export const enableOrganization = async (orgId) => {
  const response = await api.put(`/org/enable/${orgId}`);
  return response.data;
};
export const disableOrganization = async (orgId) => {
  const response = await api.put(`/org/disable/${orgId}`);
  return response.data;
};
export const deleteOrganization = async (orgId) => {
  const res = await api.delete(
    `/org/delete/${orgId}`
  );
  return res.data;
};
/* ======================
   USERS (ADMIN / ORG)
====================== */
export const getAllOrgUsers = async (orgId) => {
  const res = await api.get(`/users/allOrgUsers?orgId=${orgId}`);
  return res.data;
};

export const createUserByOrg = async (payload) => {
  const res = await api.post("/users/create", payload);
  return res.data;
};
export const deleteUserByOrg = async (userId) => {
  const res = await api.delete(`/users/${userId}`);
  return res.data;
};
export const updateUserByOrg = async (userId, data) => {
  const res = await api.patch(`/users/${userId}`, data);
  return res.data;
};
/* ======================
   AGENTS
====================== */
export const createAgent = async (payload) => {
  const res = await api.post("/agents/create", payload);
  return res.data;
};

export const getAllOrgAgents = async (orgId) => {
  const res = await api.get(`/agents/org/${orgId}`);
  return res.data;
};


export const deleteAgentByOrg = async (cnic) => {
  const res = await api.delete(`/agents/delete/${cnic}`);
  return res.data;
};
export const updateAgentByOrg = async (cnic, data) => {
  const res = await api.put(`/agents/update/${cnic}`, data);
  return res.data;
};
export const markAgentPaymentDone = async (cnic) => {
  const res = await api.put(`agents/payment-complete?cnic=${cnic}`);
  return res.data;
};
export const getAgentEarnings = async (cnic) => {
  const res = await api.get(`/agents/earnings/${cnic}`);
  return res.data;
};
export const getAgentMerchants = async (id,params) => {
  const res = await api.get(`/agents/merchants/${id}?${params}`);
  return res.data;
};
export const getAgentMerchantsStats = async (id) => {
  const res = await api.get(`/agents/stats/${id}`);
  return res.data;
};
export const getMerchantProfile = async (merchantID) => {
  console.log(`/agents/merchants/profile/${merchantID}`)
  const res = await api.get(`/agents/merchants/profile/${merchantID}`);
  return res.data;
};
export const getMerchantTransactionStats = async (merchantID) => {
  const res = await api.get(`agents/merchants/${merchantID}/stats`);
  return res.data;
};

export const getMerchantTransactions = async (merchantID, params) => {
  const res = await api.get(`agents/merchants/${merchantID}/transactions?${params}`);
  return res.data;
};
/* ======================
   PORTAL – MERCHANT / TERMINAL
====================== */
export const getMerchantTerminalStats = async () => {
  const res = await api.get("/merchant-terminal-stat");
  return res.data;
};

export const getAllMerchants = async (orgId) => {
  const res = await api.get(`/merchant/merchants-by-org/${orgId}`);
  return res.data;
};

/* ---- Portal Merchants (organization admin merchant management) ---- */

// Dashboard summary KPIs for the org's merchant network
export const getPortalMerchantSummary = async (orgId) => {
  const res = await api.get(`/merchant/portal-merchant-summary?orgId=${orgId}`);
  return res.data;
};

// Paginated / filterable merchants list (server-side)
export const getPortalMerchantsList = async (params = {}) => {
  const {
    orgId,
    page = 1,
    limit = 10,
    tab = "all",
    category = "all",
    region = "all",
    sort = "newest",
    search = "",
  } = params;

  const query = new URLSearchParams({
    orgId: String(orgId),
    page: String(page),
    limit: String(limit),
    tab,
    category,
    region,
    sort,
  });
  if (search) query.set("search", search);

  const res = await api.get(`/merchant/portal-merchants-list?${query.toString()}`);
  return res.data;
};

// Approval queue widget
export const getMerchantApprovalQueue = async (orgId, limit = 5) => {
  const res = await api.get(`/merchant/approval-queue?orgId=${orgId}&limit=${limit}`);
  return res.data;
};

// Merchant health distribution
export const getMerchantHealthDistribution = async (orgId) => {
  const res = await api.get(`/merchant/health-distribution?orgId=${orgId}`);
  return res.data;
};

// Approve a merchant (send approval request)
export const sendMerchantApprovalRequest = async (merchantID) => {
  const res = await api.put(`/merchant/send-approval-request/${merchantID}`);
  return res.data;
};

/* ======================
   ORG DASHBOARD (organization admin home)
====================== */
export const getOrgDashboardSummary = async (orgId) => {
  const res = await api.get(`/org/org-dashboard/summary?orgId=${orgId}`);
  return res.data;
};
export const getOrgTransactionTrend = async (orgId, range = "year") => {
  const res = await api.get(`/org/org-dashboard/transaction-trend?orgId=${orgId}&range=${range}`);
  return res.data;
};
export const getOrgMerchantGrowth = async (orgId, range = "day") => {
  const res = await api.get(`/org/org-dashboard/merchant-growth?orgId=${orgId}&range=${range}`);
  return res.data;
};
export const getOrgQrUsageSplit = async (orgId) => {
  const res = await api.get(`/org/org-dashboard/qr-usage-split?orgId=${orgId}`);
  return res.data;
};
export const getOrgTopAgents = async (orgId, limit = 5) => {
  const res = await api.get(`/org/org-dashboard/top-agents?orgId=${orgId}&limit=${limit}`);
  return res.data;
};
export const getOrgTopMerchants = async (orgId, limit = 5) => {
  const res = await api.get(`/org/org-dashboard/top-merchants?orgId=${orgId}&limit=${limit}`);
  return res.data;
};
export const getOrgDashboardRecentTransactions = async (orgId, limit = 10) => {
  const res = await api.get(`/org/org-dashboard/recent-transactions?orgId=${orgId}&limit=${limit}`);
  return res.data;
};
export const getOrgDashboardApprovals = async (orgId, limit = 5) => {
  const res = await api.get(`/org/org-dashboard/approvals?orgId=${orgId}&limit=${limit}`);
  return res.data;
};
export const getOrgAgentActivity = async (orgId, limit = 10) => {
  const res = await api.get(`/org/org-dashboard/agent-activity?orgId=${orgId}&limit=${limit}`);
  return res.data;
};
export const getOrgMonthlyRevenueHeatmap = async (orgId, year = new Date().getFullYear()) => {
  const res = await api.get(`/org/org-dashboard/monthly-revenue-heatmap?orgId=${orgId}&year=${year}`);
  return res.data;
};

/* ======================
   ORG AGENTS (list, details, lifecycle)
====================== */
export const getAgentsDashboardSummary = async (orgId) => {
  const res = await api.get(`/agents/dashboard-summary?orgId=${orgId}`);
  return res.data;
};
export const listOrgAgents = async (params = {}) => {
  const {
    orgId,
    page = 1,
    limit = 10,
    dateRange = "last30days",
    status = "all",
    search = "",
  } = params;

  const query = new URLSearchParams({
    orgId: String(orgId),
    page: String(page),
    limit: String(limit),
    dateRange,
    status,
  });
  if (search) query.set("search", search);

  const res = await api.get(`/agents/list?${query.toString()}`);
  return res.data;
};
export const getAgentDetails = async (agentId) => {
  const res = await api.get(`/agents/details/${agentId}`);
  return res.data;
};
export const getAgentDetailsActivity = async (agentId, limit = 10) => {
  const res = await api.get(`/agents/details/${agentId}/activity?limit=${limit}`);
  return res.data;
};
export const suspendAgent = async (agentId) => {
  const res = await api.put(`/agents/details/${agentId}/suspend`);
  return res.data;
};
export const activateAgent = async (agentId) => {
  const res = await api.put(`/agents/details/${agentId}/activate`);
  return res.data;
};
export const getAgentProfileDashboard = async (agentId) => {
  const res = await api.get(`/agents/agent-profile-dashboard/${agentId}`);
  return res.data;
};
export const getAgentProfileMerchantPortfolio = async (agentId, limit = 5) => {
  const res = await api.get(`/agents/agent-profile-dashboard/${agentId}/merchant-portfolio?limit=${limit}`);
  return res.data;
};
export const getAgentProfileRecentActivity = async (agentId, limit = 10) => {
  const res = await api.get(`/agents/agent-profile-dashboard/${agentId}/recent-activity?limit=${limit}`);
  return res.data;
};
export const releaseAgentPayout = async (id) => {
  const res = await api.put(`/agents/agent-profile-dashboard/payment-complete?id=${id}`);
  return res.data;
};

/* ======================
   ORG TRANSACTIONS / ANALYTICS (agents/org-*)
====================== */
export const getOrgTransactionSummary = async (orgId, dateRange = "last7days") => {
  const res = await api.get(`/agents/org-transaction-summary?orgId=${orgId}&dateRange=${dateRange}`);
  return res.data;
};
export const getOrgRevenueTrend = async (orgId, dateRange = "last7days") => {
  const res = await api.get(`/agents/org-revenue-trend?orgId=${orgId}&dateRange=${dateRange}`);
  return res.data;
};
export const getOrgMerchantDistribution = async (orgId) => {
  const res = await api.get(`/agents/org-merchant-distribution?orgId=${orgId}`);
  return res.data;
};
export const getOrgRecentTransactions = async (params = {}) => {
  const {
    orgId,
    page = 1,
    limit = 10,
    merchantID = "all",
    agentId = "all",
    status = "all",
    qrType = "both",
    dateRange = "last7days",
    search = "",
  } = params;

  const query = new URLSearchParams({
    orgId: String(orgId),
    page: String(page),
    limit: String(limit),
    merchantID,
    agentId,
    status,
    qrType,
    dateRange,
  });
  if (search) query.set("search", search);

  const res = await api.get(`/agents/org-recent-transactions?${query.toString()}`);
  return res.data;
};
export const getOrgSystemAlerts = async (orgId) => {
  const res = await api.get(`/agents/org-system-alerts?orgId=${orgId}`);
  return res.data;
};
export const getOrgFailedPayments = async (orgId, limit = 5) => {
  const res = await api.get(`/agents/org-failed-payments?orgId=${orgId}&limit=${limit}`);
  return res.data;
};

/* ======================
   ORG USER MANAGEMENT (users/org-users/*)
====================== */
export const listOrgUsersManaged = async (params = {}) => {
  const {
    orgId,
    page = 1,
    limit = 10,
    role = "all",
    status = "all",
    sortBy = "newest",
    search = "",
  } = params;

  const query = new URLSearchParams({
    orgId: String(orgId),
    page: String(page),
    limit: String(limit),
    role,
    status,
    sortBy,
  });
  if (search) query.set("search", search);

  const res = await api.get(`/users/org-users/list?${query.toString()}`);
  return res.data;
};
export const getOrgUsersAuditTimeline = async (orgId, limit = 10) => {
  const res = await api.get(`/users/org-users/audit-timeline?orgId=${orgId}&limit=${limit}`);
  return res.data;
};

/* ======================
   REPORT CENTER (report-center/*)
====================== */
export const getReportSummary = async (orgId) => {
  const res = await api.get(`/report-center/report-summary?orgId=${orgId}`);
  return res.data;
};
export const getReportVolumeTrends = async (orgId) => {
  const res = await api.get(`/report-center/report-volume-trends?orgId=${orgId}`);
  return res.data;
};
export const getReportRecentActivity = async (orgId, page = 1, limit = 10) => {
  const res = await api.get(`/report-center/report-recent-activity?orgId=${orgId}&page=${page}&limit=${limit}`);
  return res.data;
};
export const generateMerchantReport = async (orgId) => {
  const res = await api.get(`/report-center/report-generate/merchant?orgId=${orgId}`);
  return res.data;
};
export const generateAgentReport = async (orgId) => {
  const res = await api.get(`/report-center/report-generate/agent?orgId=${orgId}`);
  return res.data;
};
export const generateTransactionReport = async (orgId) => {
  const res = await api.get(`/report-center/report-generate/transaction?orgId=${orgId}`);
  return res.data;
};

/* ======================
   REPORTING / TXNS
====================== */
export const getReportingStats = async () => {
  const res = await api.get("/portal/reportingStats");
  return res.data;
};

export const getTotalTransactions = async () => {
  const res = await api.get("/portal/totalTransactions");
  return res.data;
};

export const getSettledTransactions = async () => {
  const res = await api.get("/portal/settledTransactions");
  return res.data;
};

export const getUnsettledTransactions = async () => {
  const res = await api.get("/portal/unsettledTransactions");
  return res.data;
};

export const getDisputedTransactions = async () => {
  const res = await api.get("/portal/disputedTransactions");
  return res.data;
};

export const getTodayTransactions = async () => {
  const res = await api.get("/portal/todayTransactions");
  return res.data;
};

/* ======================
   TERMINALS
====================== */
export const createTerminal = async (body) => {
  const res = await api.post("/createTerminal", {
    TID: body.terminalId,
    MID: body.merchantId,
    PhoneNumber: `+${body.phoneNumber}`,
    attended: body.attended,
    cardholderActivated: body.cardholderActivated,
    cardPresenceCapability: body.cardPresenceCapability,
    inputCapability: body.inputCapability,
    lane: body.lane,
    location: body.location,
    onlineReasonCode: body.onlineReasonCode,
    panEntryMode: body.panEntryMode,
    pinEntryCapability: body.pinEntryCapability,
    cards: body.cards,
    environment: body.environment,
    transactionType: body.transactionType,
  });
  return res.data;
};

export const updateTerminal = async (body) => {
  const res = await api.put(
    `/portal/updateTerminal/${body.terminalId}`,
    body
  );
  return res.data;
};

export const deleteTerminalByID = async (terminalId) => {
  const res = await api.delete(
    `/portal/deleteTerminal/${terminalId}`
  );
  return res.data;
};

/* ======================
   MERCHANT
====================== */
export const onboardMerchant = async (payload) => {
  const res = await api.post("/merchant-onboard", payload);
  return res.data;
};

export const updateMerchant = async (payload) => {
  const res = await api.put(
    `/portal/updateMerchant/${payload.MID}`,
    payload
  );
  return res.data;
};

export const deleteMerchantByID = async (MID) => {
  const res = await api.delete(`/portal/deleteMerchant/${MID}`);
  return res.data;
};

/* ======================
   PORTAL SETTINGS
====================== */
export const updateNacType = async (nacType) => {
  const res = await api.post("/portal/update-nac", { nacType });
  return res.data;
};

export const updateMessage210 = async (message210) => {
  const res = await api.post("/portal/update-message210", {
    message210,
  });
  return res.data;
};

export default api;
